<template>
  <div class="d-flex flex-column flex-column-fluid qbank-section">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="#" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">الرئيسية</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->

    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div v-if="isloading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>

        <div v-if="isLoggedIn == true" class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-md-12">
            <infoDetails />
          </div>
        </div>
      </div>
    </div>
    <!--begin::Col-->

    <!--end::Col-->

  </div>

</template>

<script>
import { apiUrl, baseUrl } from "@/utils/api";

import infoDetails from "./infoDetails.vue";


export default {
  name: "QuizReiview",
  components: {
    infoDetails,
  },
  data() {
    return {
      categories: [],
      subCategories: [],
      isloading: true,
      token: localStorage.getItem("access_token"),
      courseCount: 0,
      isLoggedIn: false,
      walletBalance: 0,
      catImagePath: baseUrl + "/images/category/",
      defaultImage: "/assets/img/acad-icon.png",
      student: {},
      loadingCategories: true, // Loading state for categories
      loadingCourses: true, // Loading state for courses
      loadingBalance: true, // Loading state for wallet balance
      currentStep: 1, // بداية في الخطوة 1
      selectedOption: "", // البيانات للـ select box
      textInput: "", // البيانات للـ input text
      numberInput: "", // البيانات للـ input number
      isChecked: false, // البيانات للـ checkbox
    };
  },
  mounted() {
    this.getBalance();
  },
  methods: {
    nextStep() {
      if (this.currentStep < 5) {
        this.currentStep++;
      }
    },
    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    finishWizard() {
      alert("تم إكمال النموذج بنجاح!");
      // يمكنك إضافة أي وظيفة لإنهاء النموذج
    },
    async getBalance() {
      this.loadingBalance = true; // Start loading
      try {
        const response = await fetch(
          `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (response.ok) {
          const data = await response.json();
          this.walletBalance = data.wallet_balance;
          this.isloading = false;
          this.isLoggedIn = true;
        } else {
          console.error("Failed to fetch balance");
          this.isloading = false;

        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {
        this.loadingBalance = false; // Stop loading
        this.isloading = false;
      }
    },

    handleImageError(event) {
      // استبدال الصورة بصورة افتراضية إذا حدث خطأ مثل 404
      event.target.src = this.defaultImage;
    }
  },
};
</script>

<style scoped></style>
